import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

const EventListener = ({ userId }) => {
  const navigate = useNavigate();

  return null; // Este componente não renderiza nada
};

export default EventListener;